import React from "react";

const ProfERolfeModel: React.FC = () => (
  <section className="pe-section pe-section--white pe-rolfe">
    <div className="pe-container">
      <div className="pe-rolfe__heading">
        <div className="pe-eyebrow">Proven Reflection Model</div>
        <h2 className="pe-rolfe__h">The Rolfe Reflection Model</h2>
      </div>

      <div className="pe-rolfe__stage">
        <div className="pe-rolfe__copy pe-rolfe__copy--left">
          <strong>The &ldquo;What&rdquo; Stage</strong>
          Describe the experience or event without analysis. Focus on the facts and details
          of what happened — actions taken, outcomes observed.
        </div>

        <div className="pe-rolfe__diagram" aria-hidden="true">
          <svg viewBox="0 0 540 460">
            {/* mascot rendered first so circles paint on top */}
            <image
              href="/images/prof-e/pose-5-thinking.png"
              x="200"
              y="148"
              width="140"
              height="180"
              preserveAspectRatio="xMidYMid meet"
            />
            {/* dashed connecting arcs */}
            <path
              d="M 170 130 Q 270 80 370 130"
              stroke="#1AC6DA"
              strokeWidth="2.5"
              fill="none"
              strokeDasharray="6 5"
            />
            <path
              d="M 400 180 Q 440 290 350 350"
              stroke="#1AC6DA"
              strokeWidth="2.5"
              fill="none"
              strokeDasharray="6 5"
            />
            <path
              d="M 200 360 Q 100 320 130 200"
              stroke="#1AC6DA"
              strokeWidth="2.5"
              fill="none"
              strokeDasharray="6 5"
            />
            {/* arrowheads */}
            <polygon points="370,130 360,124 360,138" fill="#1AC6DA" />
            <polygon points="350,350 358,338 348,338" fill="#1AC6DA" />
            <polygon points="130,200 138,210 124,210" fill="#1AC6DA" />
            {/* WHAT circle */}
            <circle cx="150" cy="160" r="56" fill="white" stroke="#1AC6DA" strokeWidth="3" />
            <text
              x="150"
              y="167"
              textAnchor="middle"
              fontFamily="Fredoka"
              fontSize="20"
              fill="#15394A"
              fontWeight="700"
            >
              What?
            </text>
            {/* SO WHAT circle */}
            <circle cx="390" cy="160" r="56" fill="white" stroke="#1AC6DA" strokeWidth="3" />
            <text
              x="390"
              y="152"
              textAnchor="middle"
              fontFamily="Fredoka"
              fontSize="18"
              fill="#15394A"
              fontWeight="700"
            >
              So
            </text>
            <text
              x="390"
              y="180"
              textAnchor="middle"
              fontFamily="Fredoka"
              fontSize="20"
              fill="#15394A"
              fontWeight="700"
            >
              What?
            </text>
            {/* NOW WHAT circle */}
            <circle cx="270" cy="380" r="56" fill="white" stroke="#1AC6DA" strokeWidth="3" />
            <text
              x="270"
              y="372"
              textAnchor="middle"
              fontFamily="Fredoka"
              fontSize="18"
              fill="#15394A"
              fontWeight="700"
            >
              Now
            </text>
            <text
              x="270"
              y="400"
              textAnchor="middle"
              fontFamily="Fredoka"
              fontSize="20"
              fill="#15394A"
              fontWeight="700"
            >
              What?
            </text>
            {/* thinking spiral above mascot */}
            <path
              d="M 320 145 q 12 -10 22 2 q 8 8 0 16 q -6 6 -12 0 q -4 -4 0 -8 q 3 -2 4 1"
              stroke="#0E9FB3"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <div className="pe-rolfe__copy pe-rolfe__copy--right">
          <strong>The &ldquo;So What&rdquo; Stage</strong>
          Analyse and interpret the experience. Understand the significance of the event,
          what it taught you, and how it relates to broader concepts or personal growth.
        </div>

        <div className="pe-rolfe__copy pe-rolfe__copy--bottom">
          <strong>The &ldquo;Now What&rdquo; Stage</strong>
          Consider what actions to take based on your reflections. Plan changes or
          improvements for future situations, ensuring the reflection leads to tangible
          outcomes.
        </div>
      </div>
    </div>
  </section>
);

export default ProfERolfeModel;
